const initialStatePersonnelRole = {
  personnel_role: [],
  update_personnel_role: false,
};

export default initialStatePersonnelRole;